"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computePlayerProjectedMs = computePlayerProjectedMs;
exports.computeTeeTimePaceMetrics = computeTeeTimePaceMetrics;
function buildElapsedByScoreCode(nowMs, paceClocks) {
    const clocksWithStart = paceClocks.filter((c) => c.startTime);
    if (clocksWithStart.length === 0)
        return null;
    const elapsedByScoreCode = new Map();
    for (const clock of clocksWithStart) {
        const elapsed = Math.max(0, nowMs - new Date(clock.startTime).getTime());
        elapsedByScoreCode.set(clock.scoreCode ?? null, elapsed);
    }
    return elapsedByScoreCode;
}
function computePlayerProjectedMs(player, totalHoles, elapsedByScoreCode, avgElapsedMs) {
    if (player.holesCompleted <= 0)
        return null;
    const playerElapsed = elapsedByScoreCode.get(player.scoreCode)
        ?? elapsedByScoreCode.get(null)
        ?? avgElapsedMs;
    return (playerElapsed / player.holesCompleted) * totalHoles;
}
/**
 * Tee-time pace: average elapsed across pace clocks; average projected finish
 * across players (each player's projection uses their matched clock elapsed).
 */
function computeTeeTimePaceMetrics(nowMs, totalHoles, targetHours, players, paceClocks) {
    const elapsedByScoreCode = buildElapsedByScoreCode(nowMs, paceClocks);
    if (!elapsedByScoreCode) {
        return {
            avgElapsedMs: 0,
            avgProjectedMs: 0,
            isOOP: false,
            hasPace: false,
            playerMetrics: players.map((p) => ({ scoreCode: p.scoreCode, projectedMs: null })),
        };
    }
    const elapsedValues = [...elapsedByScoreCode.values()];
    const avgElapsedMs = elapsedValues.reduce((a, b) => a + b, 0) / elapsedValues.length;
    const playerMetrics = [];
    const projections = [];
    for (const player of players) {
        const projectedMs = computePlayerProjectedMs(player, totalHoles, elapsedByScoreCode, avgElapsedMs);
        playerMetrics.push({ scoreCode: player.scoreCode, projectedMs });
        if (projectedMs !== null)
            projections.push(projectedMs);
    }
    const avgProjectedMs = projections.length > 0
        ? projections.reduce((a, b) => a + b, 0) / projections.length
        : 0;
    const targetMs = targetHours * 60 * 60 * 1000;
    const isOOP = avgProjectedMs > 0 && avgProjectedMs > targetMs;
    return {
        avgElapsedMs,
        avgProjectedMs,
        isOOP,
        hasPace: true,
        playerMetrics,
    };
}
